import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { paletteOptions } from "@portal/app/_components/theme/options/palette";
import { HomepageHeaderTypography } from "@portal/app/HomePage";

const steps = [
  {
    number: 1,
    label: "Search",
    description: "Browse programs by industry, location, or schedule.",
  },
  {
    number: 2,
    label: "Compare",
    description: "See pricing, reviews, and class details side-by-side.",
  },
  {
    number: 3,
    label: "Enroll",
    description: "Your coach helps you through every step of enrollment.",
  },
];

export const HomeFindAClassSection = () => (
  <Section>
    <HomepageHeaderTypography sx={{ color: "white" }}>How Dreambound works</HomepageHeaderTypography>
    <StepsRow>
      {steps.map(({ number, label, description }, index) => (
        <StepItem key={label}>
          {index > 0 && <StepConnector />}
          <StepContent>
            <StepNumber>{number}</StepNumber>
            <Typography className="step_label">{label}</Typography>
            <Typography className="step_description">{description}</Typography>
          </StepContent>
        </StepItem>
      ))}
    </StepsRow>
  </Section>
);

const Section = styled("section")`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5rem 1rem;
  max-width: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;
  background: ${paletteOptions.primary.main};

  ${({ theme }) => theme.breakpoints.down("md")} {
    padding: 3rem 1rem;
  }
`;

const StepsRow = styled("div")`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  margin-top: 3rem;
  width: 100%;
  max-width: 56rem;

  ${({ theme }) => theme.breakpoints.down("md")} {
    flex-direction: column;
    align-items: center;
    margin-top: 2rem;
  }
`;

const StepItem = styled("div")`
  display: flex;
  align-items: flex-start;
  flex: 1;

  ${({ theme }) => theme.breakpoints.down("md")} {
    flex-direction: column;
    align-items: center;
    width: 100%;
  }
`;

const StepConnector = styled("div")`
  width: 4rem;
  border-top: 2px dashed rgba(255, 255, 255, 0.35);
  margin-top: 1.75rem;
  flex-shrink: 0;

  ${({ theme }) => theme.breakpoints.down("md")} {
    width: 2px;
    height: 2rem;
    border-top: none;
    border-left: 2px dashed rgba(255, 255, 255, 0.35);
    margin: 0.75rem 0;
  }
`;

const StepContent = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  flex: 1;
  padding: 0 1rem;

  .step_label {
    font-size: 1.35rem;
    font-weight: 700;
    color: white;
    margin-top: 1rem;
  }

  .step_description {
    color: rgba(255, 255, 255, 0.9);
    font-size: 1rem;
    line-height: 1.55;
    margin-top: 0.5rem;
    max-width: 14rem;
  }
`;

const StepNumber = styled("div")`
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 50%;
  background: white;
  color: ${paletteOptions.primary.main};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: 700;
  flex-shrink: 0;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
`;
